import React, { useState, useEffect } from "react";
import clsx from "clsx";
import { useFormChangeHandler } from "hooks/useFormChangeHandler";
import { useSubmitHandler } from "hooks/useSubmitHandler";
import { useCreateData, useUpdateData } from "hooks/useApiHooks";
import { buildQueryString } from "utils/queryHelpers";

const CreatePage = ({ initialData, onSuccess, onError }) => {
  const API_URL = "/product"; // Menggunakan endpoint produk

  // State untuk menyimpan form data. Jika initialData tersedia, isi form untuk update
  const [formData, setFormData] = useState({
    name: "", // Nama produk
    price: "", // Harga produk
    price_sale: "", // Harga publish
  });

  const isUpdateMode = !!initialData; // Cek apakah ini update mode atau create mode

  // API hook untuk create dan update
  const { createData: createProduct, loading: creatingProduct } = useCreateData(
    API_URL,
    "products"
  );
  const { updateData: updateProduct, loading: updatingProduct } = useUpdateData(
    `${API_URL}/${initialData?.id}`,
    "products"
  );

  // Gunakan hook untuk menangani perubahan form
  const handleChange = useFormChangeHandler(setFormData);

  // Fungsi untuk mengonversi harga ke format yang sesuai untuk ditampilkan di form
  // const formatPrice = (value) => {
  //   return value.replace(/\D/g, "").replace(/(\d)(\d{3})(?=\d)/g, "$1,$2");
  // };

  const formatPrice = (value) => {
    return value.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };

  // Fungsi untuk menangani perubahan harga dalam format input
  const handlePriceChange = (e) => {
    const formattedValue = formatPrice(e.target.value);
    setFormData({
      ...formData,
      [e.target.name]: formattedValue,
    });
  };

  // Fungsi untuk menangani pengiriman form
  const { handleSubmit, isSubmitting, formError } = useSubmitHandler(
    isUpdateMode ? updateProduct : createProduct,
    onSuccess,
    onError
  );

  const handleBeforeSubmit = (e) => {
    e.preventDefault();

    // Mengonversi harga yang diformat kembali ke angka integer
    // const payload = {
    //   ...formData,
    //   price: parseInt(formData.price.replace(/,/g, "")),
    //   price_sale: parseInt(formData.price_sale.replace(/,/g, "")),
    // };

    const payload = {
      ...formData,
      price: parseInt(formData.price.replace(/\./g, "")),
      price_sale: parseInt(formData.price_sale.replace(/\./g, "")),
    };

    handleSubmit(payload, e);
  };

  // useEffect(() => {
  //   if (initialData) {
  //     setFormData({
  //       ...initialData,
  //       price: initialData.price.toLocaleString(), // Format harga untuk form
  //       price_sale: initialData.price_sale.toLocaleString(), // Format harga publish untuk form
  //     });
  //   }
  // }, [initialData]);

  useEffect(() => {
    // Jika data produk berubah (untuk update), isi ulang form data
    if (initialData) {
      setFormData({
        ...initialData,
        price: formatPrice(Math.floor(initialData.price).toString()), // Buang desimal, lalu format
        price_sale: formatPrice(Math.floor(initialData.price_sale).toString()), // Buang desimal, lalu format
      });
    }
  }, [initialData]);
  

  return (
    <form
      onSubmit={(e) => handleBeforeSubmit(e)}
      className="d-flex flex-column"
      style={{ height: "100%" }}
    >
      <div className="action-sheet-content flex-grow-1">
        {/* Product Name */}
        <div className="row mb-3 align-items-center">
          <label
            htmlFor="name"
            className="col-sm-4 col-form-label d-flex justify-content-end"
            style={{ fontSize: "14px" }}
          >
            Product Name:
          </label>
          <div className="col-sm-8">
            <input
              type="text"
              className={clsx(
                "form-control gotra-form-control rounded-1",
                formError?.name && "is-invalid"
              )}
              id="name"
              placeholder="Product Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              disabled={isSubmitting}
              style={{ fontSize: "14px", height: "35px" }}
              required
              minLength={3}
            />
            {formError?.name && (
              <div className="invalid-feedback">{formError.name}</div>
            )}
          </div>
        </div>

        {/* Price */}
        <div className="row mb-3 align-items-center">
          <label
            htmlFor="price"
            className="col-sm-4 col-form-label d-flex justify-content-end"
            style={{ fontSize: "14px" }}
          >
            Price:
          </label>
          <div className="col-sm-8">
            <input
              type="text"
              className={clsx(
                "form-control gotra-form-control rounded-1",
                formError?.price && "is-invalid"
              )}
              id="price"
              placeholder="Price"
              name="price"
              value={formData.price}
              onChange={handlePriceChange} // Handle price format
              disabled={isSubmitting}
              style={{ fontSize: "14px", height: "35px" }}
              required
            />
            {formError?.price && (
              <div className="invalid-feedback">{formError.price}</div>
            )}
          </div>
        </div>

        {/* Published Price */}
        <div className="row mb-3 align-items-center">
          <label
            htmlFor="price_sale"
            className="col-sm-4 col-form-label d-flex justify-content-end"
            style={{ fontSize: "14px" }}
          >
            Published Price:
          </label>
          <div className="col-sm-8">
            <input
              type="text"
              className={clsx(
                "form-control gotra-form-control rounded-1",
                formError?.price_sale && "is-invalid"
              )}
              id="price_sale"
              placeholder="Published Price"
              name="price_sale"
              value={formData.price_sale}
              onChange={handlePriceChange} // Handle price format
              disabled={isSubmitting}
              style={{ fontSize: "14px", height: "35px" }}
              required
            />
            {formError?.price_sale && (
              <div className="invalid-feedback">{formError.price_sale}</div>
            )}
          </div>
        </div>

        {/* Submit Button */}
        <div className="form-group mt-auto d-grid">
          <button
            type="submit"
            className="btn btn-primary btn-block"
            disabled={isSubmitting}
          >
            {isUpdateMode ? "Update Product" : "Create Product"}
          </button>
        </div>
      </div>
    </form>
  );
};

export default CreatePage;
